import React from "react";
import { Send } from "lucide-react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function ShareDraftDialog({ open, onOpenChange, data, setData, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share Draft with Supplier</DialogTitle>
          <DialogDescription>Send a PDF draft of this contract to the supplier for review before signatures.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Recipient Name</Label>
            <input
              className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm"
              value={data.recipient_name}
              onChange={(e) => setData({ ...data, recipient_name: e.target.value })}
              placeholder="Supplier contact name"
              data-testid="share-draft-name"
            />
          </div>
          <div className="space-y-2">
            <Label>Recipient Email *</Label>
            <input
              type="email"
              className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm"
              value={data.recipient_email}
              onChange={(e) => setData({ ...data, recipient_email: e.target.value })}
              placeholder="supplier@company.com"
              data-testid="share-draft-email"
            />
          </div>
          <div className="space-y-2">
            <Label>Message (optional)</Label>
            <textarea
              className="flex min-h-[60px] w-full rounded-sm border border-input bg-background px-3 py-2 text-sm"
              value={data.message}
              onChange={(e) => setData({ ...data, message: e.target.value })}
              placeholder="Please review this draft contract..."
              rows={3}
              data-testid="share-draft-message"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
          <Button onClick={onSubmit} className="rounded-sm gap-2" data-testid="send-draft-btn">
            <Send size={16} /> Send Draft PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function AddendumWorkflowDialog({ open, onOpenChange, users, user, reviewers, setReviewers, approvers, setApprovers, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Submit Addendum for Review</DialogTitle>
          <DialogDescription>Select reviewers and approvers for this addendum</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Reviewer(s)</Label>
            <Select value={reviewers[0] || ""} onValueChange={(v) => setReviewers([v])}>
              <SelectTrigger className="rounded-sm" data-testid="addendum-reviewer-select"><SelectValue placeholder="Select reviewer" /></SelectTrigger>
              <SelectContent>
                {users.filter((u) => u.id !== user?.id).map((u) => (
                  <SelectItem key={u.id} value={u.id}>{u.name} ({u.role})</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Approver(s)</Label>
            <Select value={approvers[0] || ""} onValueChange={(v) => setApprovers([v])}>
              <SelectTrigger className="rounded-sm" data-testid="addendum-approver-select"><SelectValue placeholder="Select approver" /></SelectTrigger>
              <SelectContent>
                {users.filter((u) => u.id !== user?.id && !reviewers.includes(u.id)).map((u) => (
                  <SelectItem key={u.id} value={u.id}>{u.name} ({u.role})</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
          <Button onClick={onSubmit} className="rounded-sm" data-testid="submit-addendum-workflow-btn">Submit for Review</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
